import { OpenAiGatewayBase } from './base'
import { toChatSeed } from './translator/chat'
import { IChatProps } from '@/entities/ChatGPT/Chat'
import { Completions } from '@/infrastructure/network/OpenAi/requests/chat'

export default class Chat extends OpenAiGatewayBase {
  async Completions(props: IChatProps) {
    return await this.apiClient.stream(new Completions(toChatSeed(props)))
  }

  async O1Completions(props: IChatProps) {
    return await this.apiClient.request(new Completions(toChatSeed(props)))
  }
}
